import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../../services/KeycloakService';
import {
  getApplicationStatuses,
  getUserData,
  getWfhRequest,
  updateApplicationStatus,
} from '../../../services/UserService';
import {
  RESET_DATE_RANGE,
  SHOW_NOTIFICATION,
  WFHAttribute,
} from '../../../constants';
import GenericLoader from '../../../components/Loader/GenericLoader';
import PaginationComponent from '../../../components/Pagination/Pagination';
import { Box } from '@mui/system';
import { getHRWFHRequests } from '../../services/LeaveService';
import LeaveStatusCardComponent from '../../../components/LeaveStatusCard/LeaveStatusCardComponent';
import { NO_WFH_REQUESTS } from '../../../pages/Manage/ManageConstants';
import { Grid, Typography } from '@mui/material';
import GenericFilterDrawer from '../../../components/GenericFilter/GenericFilterDrawer';
import { getProjectsByName } from '../../../services/ProjectService';
import {
  resetFilterDataState,
  setFilterConfig,
} from '../../../modules/filter/filterAction';
import { checkFilterIconVisibility } from '../../../components/GenericFilter/FilterIconVisibilityCheck';
import { cardComponentCollapse } from '../../../modules/cardState/cardAction';
import HrWfhStatusComponent from '../../components/HrWfhStatusComponent';

const ManageHrWfhRequests = (props) => {
  const [wfhRequestList, setWFHRequestList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [loader1, setLoader1] = useState(true);
  const [pageNo, setPageNo] = useState(0);
  const currentUserId = KeycloakService.getUserDetail();
  const [refreshPage, setRefreshPage] = useState(false);
  const [projectArray, setProjectArray] = useState([]);

  const [options, setOptions] = useState({});
  const filterState = useSelector((state) => state.filterState);

  useEffect(() => {
    setOptions({ ...options, project: projectArray });
  }, [projectArray]);

  const emptyFilterData = {
    employeeName: '',
    employeeId: '',
    type: '',
    status: '',
    startDate: '',
    endDate: '',
    projectName: '',
  };

  const filterConfiguration = {
    inputField: [
      [
        ['status', 'Status'],
        [
          ['APPROVED', 'Approved'],
          ['PENDING', 'Pending'],
          ['REJECTED', 'Rejected'],
          ['TASK_APPROVED', 'Task Approved'],
          ['TASK_PENDING', 'Task Pending'],
        ],
      ],
    ],
    autoComplete: [['Search Employee', 'employee']],
    dropdownField: [['Search Project', 'project', 'projectName', 'id']],
  };

  const getProjects = async (pName) => {
    const projectList = await getProjectsByName(pName, 0, null);
    if (projectList?.status === 200) {
      setProjectArray((prevProjects) => [...projectList.data.content]);
      setOptions({ ...options, project: projectList.data.content });
    } else {
      setProjectArray((prevProjects) => []);
      setOptions({ ...options, project: [] });
    }
    setLoader(false);
  };

  const resetThings = () => {
    for (let arrayOfArrays of filterConfiguration.dropdownField) {
      setOptions({ ...options, [arrayOfArrays[1]]: [] });
    }
    dispatch(setFilterConfig(filterConfiguration));
    dispatch({
      type: RESET_DATE_RANGE,
    });
    dispatch(resetFilterDataState());
    dispatch(cardComponentCollapse());
  };

  const [pageSize, setPageSize] = useState(5);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();

  const updateApplicationByHr = async (templateApplicationResponse) => {
    const updateApplicationStatusResponse = await updateApplicationStatus(
      templateApplicationResponse,
    );
    if (updateApplicationStatusResponse.isError === false) {
      setRefreshPage(!refreshPage);
    }
    dipatchNotification(
      updateApplicationStatusResponse.type,
      updateApplicationStatusResponse.message,
    );
    return updateApplicationStatusResponse;
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const empName = async (request, id) => {
    request.empName = `${request.empName}`;
  };
  const getApproversList = async (request, applicationId) => {
    const approversList = await getApplicationStatuses(applicationId);
    request.approverList = approversList?.data?.data;
  };
  const getWFHRequests = async () => {
    const wfhRequests = await getHRWFHRequests(
      currentUserId,
      filterState,
      pageSize,
      pageNo,
    );
    if (wfhRequests?.isError === false) {
      setTotalPage(wfhRequests.data.data.totalPages);
      await Promise.all(
        wfhRequests.data.data.content.map(async (request) => {
          await empName(request, request.employeeId);
          await getApproversList(request, request.id);
        }),
      );
      console.log(wfhRequests.data.data.content, 'taks');
      setWFHRequestList(wfhRequests.data.data.content);
      setLoader1(false);
      setLoader(false);
    }
    if (wfhRequests.status !== 200) {
      dipatchNotification(wfhRequests.type, wfhRequests.message);
    }
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setLoader(true);
    setRefreshPage(!refreshPage);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
  };

  const [resetFilter, setResetFilter] = useState(false);

  useEffect(() => {
    resetThings();
    getProjects();
    setResetFilter(true);
  }, []);

  const temp = useMemo(() => {
    pageChange(null, 1);
  }, [filterState]);

  useEffect(() => {
    if (resetFilter) {
      getWFHRequests();
    }
  }, [refreshPage, resetFilter]);

  return (
    <>
      {loader || loader1 ? (
        <div style={{ height: '80vh', overflow: 'hidden' }}>
          <GenericLoader rectAttributes={WFHAttribute} />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div">
            {checkFilterIconVisibility(
              filterState,
              emptyFilterData,
              wfhRequestList,
            ) && <GenericFilterDrawer options={options} />}
            <Box
              sx={{
                overflow: 'hidden',
              }}
            >
              {wfhRequestList.length != 0 ? (
                wfhRequestList.map((request, index) => {
                  if (
                    request.status === 'APPROVED' ||
                    request.status === 'TASK_PENDING' ||
                    request.status === 'TASK_APPROVED'
                  ) {
                    return (
                      <HrWfhStatusComponent
                        key={request.id}
                        wfh={request}
                        wfhStatus={request.status}
                        isManagerOrAdmin={false}
                        updateApplication={updateApplicationByHr}
                        refresh={refreshPage}
                        setRefresh={setRefreshPage}
                      />
                    );
                  } else {
                    return (
                      <LeaveStatusCardComponent
                        key={request.id}
                        leave={request}
                        leaveStatus={request.status}
                        updateApplicationByHr={updateApplicationByHr}
                      />
                    );
                  }
                })
              ) : (
                <Grid
                  container
                  item
                  md={3}
                  xs={3}
                  sx={{ height: '350px', m: 'auto' }}
                >
                  <Typography sx={{ mt: 'auto', mb: 'auto' }}>
                    {NO_WFH_REQUESTS}
                  </Typography>
                </Grid>
              )}
            </Box>
            {wfhRequestList.length ? (
              <Box className="page-holder">
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}
          </div>
        </Box>
      )}
    </>
  );
};
export default ManageHrWfhRequests;
